import React, { useEffect, useRef, useState } from 'react';
import './Recap.css';

const Recap = () => {
    const iframeRef = useRef(null);
    const [height, setHeight] = useState('100vh');

    useEffect(() => {
        const onMessage = (e) => {
            if (e?.data && typeof e.data === 'object' && e.data.type === 'recap-height') {
                setHeight(`${e.data.height}px`);
            }
        };
        window.addEventListener('message', onMessage);
        return () => window.removeEventListener('message', onMessage);
    }, []);

    return (
        <iframe
            ref={iframeRef}
            title="Digital Twin Symposium 2026 Recap"
            src="/recap/index.html"
            className="recap-iframe"
            style={{ height }}
            loading="eager"
            scrolling="auto"
            frameBorder="0"
        />
    );
};

export default Recap;
